import ApiService from "@/utils/request"

export const infoServe = {
  createBaseInfo(params) {
    return ApiService.post("alumni/info/basic/", params)
  },
  updateBaseInfo(id, params) {
    return ApiService.formPost(`alumni/info/basic/update/${id}/`, params)
  },
  getBaseInfo(id) {
    return ApiService.get(`alumni/info/${id}/`)
  },
  getEduInfo(id) {
    return ApiService.get(`alumni/info/degree/${id}/`)
  },
  createEduInfo(id, params) {
    return ApiService.post(`alumni/info/degree/${id}/`, params)
  },
  updateEduInfo(id, params) {
    return ApiService.post(`alumni/info/degree/update/${id}/`, params)
  },
  getEmployInfo(id) {
    return ApiService.get(`alumni/info/employ/${id}/`)
  },
  createUpdateEmployInfo(id, params) {
    return ApiService.post(`alumni/info/employ/${id}/`, params)
  },
  getLicenseInfo(id) {
    return ApiService.get(`alumni/info/license/${id}/`)
  },
  updateLicenseInfo(id, params) {
    return ApiService.post(`alumni/info/license/${id}/`, params)
  },
  getImg(path) {
    return ApiService.query(`alumni/img/`, { path })
  },
  getBlob(path) {
    return ApiService.query(
      `alumni/img/`,
      { path },
      {
        responseType: "blob",
        headers: {
          "Content-Disposition":
            "attachment;30b43ced-a605-4718-b47c-597a2b17c869.png",
          "Content-Type": "application/octet-stream"
        }
      }
    )
  }
}
